import _defineProperty from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { useTranslate } from '../i18n';
import AdCarbon from './AdCarbon';
import AdInHouse from './AdInHouse';
import { AdContext, adShape } from './AdManager';
import { useAdConfig } from './AdProvider';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function PleaseDisableAdblock() {
  var t = useTranslate();
  return /*#__PURE__*/_jsxs(Paper, {
    component: "span",
    elevation: 0,
    sx: {
      display: 'block',
      p: 1.5,
      border: '2px solid',
      borderColor: 'primary.main'
    },
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "body2",
      component: "span",
      gutterBottom: true,
      sx: {
        display: 'block'
      },
      children: t('likeMui')
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "body2",
      component: "span",
      gutterBottom: true,
      sx: {
        display: 'block'
      },
      children: t('adblock')
    }), /*#__PURE__*/_jsxs(Typography, {
      variant: "body2",
      component: "span",
      sx: {
        display: 'block'
      },
      children: [t('thanks'), ' ', /*#__PURE__*/_jsx("span", {
        role: "img",
        "aria-label": t('emojiLove'),
        children: "\u2764\uFE0F"
      })]
    })]
  });
}
var disableAd = false && process.env.ENABLE_AD_IN_DEV_MODE !== 'true';
var inHouseAds = [{
  name: 'templates',
  link: 'https://mui.com/store/?utm_source=docs&utm_medium=referral&utm_campaign=in-house-templates',
  img: '/static/ads-in-house/themes-2.jpg',
  descriptionHeader: 'Premium Templates',
  description: 'Start your project with the best templates for admins, dashboards, and more.'
}, {
  name: 'themes',
  link: 'https://mui.com/store/?utm_source=docs&utm_medium=referral&utm_campaign=in-house-themes',
  img: '/static/ads-in-house/themes.png',
  descriptionHeader: 'Premium Themes',
  description: 'Kickstart your application development with a ready-made theme.'
}, {
  name: 'tidelift',
  link: 'https://tidelift.com/?utm_source=npm-material-ui&utm_medium=referral&utm_campaign=enterprise&utm_content=ad',
  img: '/static/ads-in-house/tidelift.png',
  descriptionHeader: 'MUI for enterprise',
  description: 'Save time and reduce risk. Managed open source — backed by maintainers.'
}, {
  name: 'figma',
  link: 'https://mui.com/store/items/figma-react/?utm_source=docs&utm_medium=referral&utm_campaign=in-house-figma',
  img: '/static/ads-in-house/figma.png',
  descriptionHeader: 'For Figma',
  description: 'A large UI kit with over 600 handcrafted Material UI, MUI X, Joy UI components 🎨.'
}];
var AdErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function AdErrorBoundary() {
    var _this;
    _classCallCheck(this, AdErrorBoundary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AdErrorBoundary, [].concat(args));
    _this.state = {
      didError: false
    };
    return _this;
  }
  _inherits(AdErrorBoundary, _React$Component);
  return _createClass(AdErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch() {
      // send explicit `'null'`
      var eventLabel = String(this.props.eventLabel);
      // TODO: Use proper error monitoring service (for example Sentry) instead

      window.gtag('event', 'ad', {
        eventAction: 'crash',
        eventLabel: eventLabel
      });
    }
  }, {
    key: "render",
    value: function render() {
      var didError = this.state.didError;
      var children = this.props.children;
      if (didError) {
        return null;
      }
      return children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        didError: true
      };
    }
  }]);
}(React.Component);
export var AD_MARGIN_TOP = 3;
export var AD_MARGIN_BOTTOM = 3;
export var AD_HEIGHT = 126;
// Add more height on mobile as the text tends to wrap beyond the image height.
export var AD_HEIGHT_MOBILE = 126 + 16;

// https://stackoverflow.com/a/20084661
function isBot() {
  return /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);
}
export function Ad() {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    adblock = _React$useState2[0],
    setAdblock = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    carbonOut = _React$useState4[0],
    setCarbonOut = _React$useState4[1];
  var _React$useRef = React.useRef(Math.random()),
    randomAdblock = _React$useRef.current;
  var _React$useRef2 = React.useRef(Math.random()),
    randomInHouse = _React$useRef2.current;
  var children;
  var label;
  // Hide the content to google bot to avoid its indexation.
  if (true && isBot() || disableAd) {
    children = /*#__PURE__*/_jsx("span", {});
  } else if (adblock) {
    if (randomAdblock < 0.2) {
      children = /*#__PURE__*/_jsx(PleaseDisableAdblock, {});
      label = 'in-house-adblock';
    } else {
      children = /*#__PURE__*/_jsx(AdInHouse, {
        ad: inHouseAds[Math.floor(inHouseAds.length * randomInHouse)]
      });
      label = 'in-house';
    }
  } else if (carbonOut) {
    children = /*#__PURE__*/_jsx(AdInHouse, {
      ad: inHouseAds[Math.floor(inHouseAds.length * randomInHouse)]
    });
    label = 'in-house-carbon';
  } else {
    children = /*#__PURE__*/_jsx(AdCarbon, {});
    label = 'carbon';
  }
  var ad = React.useContext(AdContext);
  var eventLabel = label ? "".concat(label, "-").concat(ad.placement, "-").concat(adShape) : null;
  var timerAdblock = React.useRef(undefined);
  var checkAdblock = React.useCallback(function () {
    var attempt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if (document.querySelector('.ea-placement') || document.querySelector('#carbonads') || document.querySelector('.carbonads') || carbonOut) {
      var _document$querySelect;
      if (document.querySelector('#carbonads a') && ((_document$querySelect = document.querySelector('#carbonads a')) == null ? void 0 : _document$querySelect.getAttribute('href')) === 'https://material-ui-next.com/discover-more/backers') {
        setCarbonOut(true);
      }
      setAdblock(false);
      return;
    }
    if (attempt < 30) {
      timerAdblock.current = setTimeout(function () {
        checkAdblock(attempt + 1);
      }, 500);
    }
    if (attempt > 6) {
      setAdblock(true);
    }
  }, [carbonOut]);
  React.useEffect(function () {
    if (disableAd) {
      return undefined;
    }
    checkAdblock();
    return function () {
      clearTimeout(timerAdblock.current);
    };
  }, [checkAdblock]);
  var _useAdConfig = useAdConfig(),
    GADisplayRatio = _useAdConfig.GADisplayRatio;
  React.useEffect(function () {
    // Avoid an exceed on the Google Analytics quotas.
    if (Math.random() > (GADisplayRatio != null ? GADisplayRatio : 0.1) || !eventLabel) {
      return undefined;
    }
    var delay = setTimeout(function () {
      window.gtag('event', 'ad', {
        eventAction: 'display',
        eventLabel: eventLabel
      });
    }, 2500);
    return function () {
      clearTimeout(delay);
    };
  }, [GADisplayRatio, eventLabel]);
  return /*#__PURE__*/_jsx(Box, {
    component: "span",
    sx: function sx(theme) {
      return _extends(_defineProperty({
        position: 'relative',
        display: 'block',
        mt: AD_MARGIN_TOP,
        mb: AD_MARGIN_BOTTOM,
        minHeight: AD_HEIGHT_MOBILE
      }, theme.breakpoints.up('sm'), {
        minHeight: AD_HEIGHT
      }), adShape === 'image' && {}, adShape === 'inline' && {
        display: 'flex',
        alignItems: 'flex-end'
      });
    },
    "data-ga-event-category": "ad",
    "data-ga-event-action": "click",
    "data-ga-event-label": eventLabel,
    children: /*#__PURE__*/_jsx(AdErrorBoundary, {
      eventLabel: eventLabel,
      children: children
    })
  });
}